import React from 'react';
import './GroupDisplay.css';
import { Player } from '../types';

interface GroupDisplayProps {
  groups: Player[][];
  showOrder: boolean;
}

const GroupDisplay: React.FC<GroupDisplayProps> = ({ groups, showOrder }) => {
  if (groups.length === 0) {
    return (
      <div className="group-display-container">
        <div className="no-groups-message">
          <h3 className="no-groups-title">No Groups Generated</h3>
          <p className="no-groups-description">
            Add players and adjust your settings to generate groups
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="group-display-container">
      <h3 className="group-title">Generated Groups</h3>
      
      <div className="groups-grid">
        {groups.map((group, groupIndex) => (
          <div key={groupIndex} className="group-card">
            <div className="group-header">
              <h4 className="group-name">Group {groupIndex + 1}</h4>
              <span className="group-count">{group.length} player{group.length !== 1 ? 's' : ''}</span>
            </div>
            
            <div className="players-list">
              {group.map((player, playerIndex) => (
                <div key={player.id} className="group-player">
                  <span className="player-name">{player.name}</span>
                  {showOrder && player.order && (
                    <span className="order-badge">
                      {player.order}
                      <span className="order-suffix">
                        {player.order === 1 ? 'st' : player.order === 2 ? 'nd' : player.order === 3 ? 'rd' : 'th'}
                      </span>
                    </span>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GroupDisplay;
